import React from "react";
import { useAuth } from "../lib/auth";
import { useContent } from "../lib/content";
import { Clock, LogOut, Phone, Mail } from "lucide-react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const { t } = useContent();
  const phone = t("landing_phone", "+36 20 9 40 40 04");
  const email = t("landing_email", "info@vagparts.hu");
  // tel: URI must be digits + leading "+" only.
  const phoneHref = `tel:${phone.replace(/[^\d+]/g, "")}`;

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="topbar">
        <div className="max-w-[1200px] mx-auto px-4 h-9 flex items-center justify-between">
          <div className="flex items-center gap-2"><Phone size={11} /><span>prnds24.hu — B2B</span></div>
          <button onClick={logout} className="hover:opacity-80 flex items-center gap-1" data-testid="logout-button">
            <LogOut size={11} /> Kilépés
          </button>
        </div>
      </div>

      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="card-elev max-w-xl w-full">
          <div className="section-title" style={{ background: "linear-gradient(to bottom,#DC8A00,#B86F00)" }}>
            <Clock size={14} className="inline mr-2" /> Várja a jóváhagyást
          </div>
          <div className="p-8 text-center">
            <div
              className="w-16 h-16 mx-auto mb-5 rounded-full flex items-center justify-center"
              style={{ background: "#FFF4E0", border: "2px solid #DC8A00" }}
            >
              <Clock size={28} style={{ color: "#DC8A00" }} />
            </div>

            <h1 className="text-2xl font-bold mb-3 uppercase">Köszönjük a regisztrációt!</h1>
            <p className="text-sm mb-2" style={{ color: "var(--text-mute)" }}>
              Üdvözöljük, <strong style={{ color: "var(--text)" }}>{user?.name || user?.email}</strong>
            </p>
            <p className="text-sm mb-6" style={{ color: "var(--text-mute)" }}>
              Az ön fiókja még <strong style={{ color: "#DC8A00" }}>jóváhagyásra vár</strong>. Az alkatrész-vezetőnk hamarosan átnézi az adatait,
              és beállítja az ön egyedi szerződéses árszintjét. A jóváhagyás után belépve azonnal hozzáfér a teljes katalógushoz és
              rendelést is leadhat.
            </p>

            <div className="my-6 p-4 text-left text-xs space-y-2" style={{ background: "var(--surface-elev)", border: "1px solid var(--border)", borderRadius: 4 }}>
              <div className="font-bold uppercase mb-1" style={{ color: "var(--text)" }}>A megadott adatok:</div>
              <Detail label="E-mail" value={user?.email} />
              <Detail label="Cégnév / Műhely" value={user?.company} />
              <Detail label="Adószám" value={user?.tax_id} />
              <Detail label="Telefon" value={user?.phone} />
            </div>

            <div className="text-xs p-3 mb-5" style={{ background: "#FFFEF0", border: "1px solid var(--brand)", borderRadius: 4 }}>
              <strong>Gyorsabb feldolgozás:</strong> Hívjon minket telefonon és mondja meg az e-mail címét — perceken belül aktiváljuk a fiókot.
            </div>

            <div className="flex justify-center gap-2 flex-wrap">
              <a href={phoneHref} className="btn-primary" data-testid="call-admin-btn">
                <Phone size={14} /> Hívás: {phone}
              </a>
              <a href={`mailto:${email}`} className="btn-ghost" data-testid="email-admin-btn">
                <Mail size={14} /> {email}
              </a>
            </div>

            <p className="text-[10px] mt-6" style={{ color: "var(--text-mute)" }}>
              Az oldal néhány perc múlva újra próbálkozhat — vagy várjon az e-mail értesítésre.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}

function Detail({ label, value }) {
  if (!value) return null;
  return (
    <div className="flex justify-between">
      <span style={{ color: "var(--text-mute)" }}>{label}:</span>
      <span className="font-bold">{value}</span>
    </div>
  );
}
